import { Component, OnInit } from "@angular/core";
import { MqttService } from "src/app/services/mqtt.service";
import { CommonApiService } from "src/app/services/common-api.service";
import { first } from "rxjs/operators";
import * as moment from "moment";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from "src/environments/environment";

declare var $: any;

@Component({
  selector: "app-dashbaord",
  templateUrl: "./dashbaord.component.html",
  styleUrls: ["./dashbaord.component.scss"],
})
export class DashbaordComponent implements OnInit {
  mqttService: any;
  usageThisMonth: any;
  estConsumtion: any;
  mqttData: any;
  meter_id: any;
  meters: Array<String> = [];
  selectedMeterId: String;
  displayName: any;
  user: any;
  page: Number = 0;
  count: Number = 3;
  topApplianceUsage: any;
  startTime: any;
  loader: boolean = false;
  version: any;
  constructor(public commonApi: CommonApiService, public router: Router, public afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.version = environment.version;
    this.meter_id = this.commonApi.meter_id;
    console.log(this.meter_id);
    this.selectedMeterId = this.commonApi.getSelectedMeterId();
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getCurrentUser()
    console.log(this.user);
    this.meters = this.user["meters"];
    console.log(this.meters);
    
  }
  getCurrentUser() {

    this.commonApi.getUserData().pipe(first()).subscribe(res => {
      this.user = res;

    })
  }

  onMeterChange(ev) {
    console.log(ev);
    this.commonApi.setSelectedMeterId(ev);
    this.selectedMeterId = ev;
  }




  logout() {
    this.afAuth.signOut();
    localStorage.clear();
    this.router.navigate(["/login"]);
    localStorage.removeItem("user");
  }
  openNav() {
    // document.getElementById("mySidenav").style.width = "320px";
    document.getElementById("mySidenav").classList.add("mySidenav");
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    document.getElementById("overlay").style.display = "block";
    // document.getElementById("main").style.marginRight = "250px";
  }

  closeNav() {
    document.getElementById("mySidenav").classList.remove("mySidenav");
    document.body.style.backgroundColor = "white";
    document.getElementById("overlay").style.display = "none";
    // document.getElementById("main").style.marginRight= "0";
  }
}
